<template>
  <div>
    <application
      ref="application"
      :title="`SGUSUITE`"
      :menu="menu"
      :auth="auth"
      :user="session"
    >
      <template slot="body">
        <uni-loading
          style="position: absolute;width: 75%;"
          :loading="loading"
        ></uni-loading>
        <module-not-found v-show="isNotFoundModule" />
        <not-authorized v-show="isNotAuthorized" />
        <div
          id="module-wrapper"
          v-show="!isNotFoundModule && !isNotAuthorized"
        ></div>
      </template>
    </application>
  </div>
</template>

<script>
import { register } from "@unimed/unijs/store";
import Application from "@unimed/unijs/application";
import { render, utils } from "../utils";
import auth from "@unimed/unijs/auth";
import UniLoading from "@unimed/unijs/loading";
import ModuleNotFound from "@/components/ModuleNotFound";
import NotAuthorized from "@/components/NotAuthorized";

export default {
  components: {
    Application,
    UniLoading,
    ModuleNotFound,
    NotAuthorized
  },
  data() {
    return {
      auth: {},
      build: {},
      isNotFoundModule: false,
      isNotAuthorized: false,
      loading: true,
      menu: [],
      session: null,
      utils: {},
      beforeEachCreated: {},
      modConfig: null,
      modules: {},
      unregisterGuard: null
    };
  },
  beforeCreate() {
    if (this.$store) {
      register(this.$store);
    }

    if (this.$store.state.login && this.$store.state.login.session) {
      this.session = this.$store.state.login.session;
    } else {
      this.$router.push({ name: "login" });
    }
  },
  created() {
    this.auth = auth;
    this.utils = utils;
    this.build = render;

    this.unregisterGuard = this.$router.beforeEach((to, from, next) => {
      if (to.path.match("login")) {
        next();
      } else {
        this.$nextTick(() => {
          const modulesDropdown = this.$refs.application.$refs.modulesDropdown;

          if (modulesDropdown) modulesDropdown.closeDropdown();
        });
        this.loadRoute(to, from, next);
      }
    });
  },
  mounted() {
    if (!this.isNotFoundModule) {
      this.session = this.$store.state.login.session;
      this.menu = JSON.parse(global.localStorage.menu || "[]");
      this.loadRoute();
    }
  },
  beforeDestroy() {
    if (this.unregisterGuard) this.unregisterGuard();
  },
  methods: {
    loadRoute(
      to = this.$router.currentRoute,
      from = this.$router.currentRoute,
      next = () => ({}),
      moduleCall
    ) {
      this.loading = true;

      const name = this.utils.getModuleName(to.path);
      const currentName = this.utils.getModuleName(from.path);

      this.isNotAuthorized = false;
      if (to.path.match("login")) {
        next();
      } else {
        this.build.push(name, currentName, this).then(
          ({ module }) => {
            this.loading = false;
            this.isNotFoundModule = false;

            if (moduleCall) this.$router.push({ path: to.path });
            next();
            if (module) {
              if (!this.beforeEachCreated[name]) {
                this.beforeEachCreated[name] = true;
              }
              module.$router.push({ path: to.path });
              this.$store.commit(
                "setCurrentPath",
                module.$router.currentRoute.path
              );
            }
          },
          () => {
            this.loading = false;
            this.isNotFoundModule = true;
            next();
          }
        );
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../node_modules/@unimed/unijs/static/bulma.css";
</style>
